import { div, Button } from "@material-ui/core";
import React from "react";
import { useNavigate } from "react-router-dom";
import bars from "../../assets/images/rewards/bars.png";
import quiz from "../../assets/images/rewards/question.png";
import challenge from "../../assets/images/rewards/challenge.png";
import bookIcon from "../../assets/images/rewards/book-cricket.png";
import fantassyimage from "../../assets/images/fantasyy/fantassyentry-logo.png";
import fantasybagroundimage from "../../assets/images/fantasyy/fantassyentry-bg.png";
export default function Contest() {
  const navigate = useNavigate();
  const handleOpenprediction = () => {
    navigate("/prediction");
  };
  const handleOpenChallenge = () => {
    navigate("/challenge");
  };
  const handleOpenBookCricket = () => {
    navigate("/games/book-cricket");
  };
  const handleOpenFantasy = () => {
    navigate("/fantasy-league");
  };
  return (
    <div className="contestContainer">
      <p className="TossFontStyle contestcard">Contest</p>
      <div className="mobileGrid">
        <div className="contestmaincontainer">
          <div>
            <img src={quiz} alt="" className="contentimage" />
          </div>
          <div className="constestContent">
            <div>
              <p className="TossFontStyle contestpadding">Predictions</p>
            </div>
            <p className="giftFont contestpadding" style={{ color: "#949494" }}>
              Guess and Win
            </p>
            <div className="contestpadding">
              <Button
                className="TossFontStyle contestButton"
                onClick={handleOpenprediction}
              >
                Play Now
              </Button>
            </div>
          </div>
        </div>
        <div className="contestmaincontainer">
          <div>
            <img src={challenge} alt="" className="contentimage" />
          </div>
          <div className="constestContent">
            <div>
              <p className="TossFontStyle contestpadding">Challenge</p>
            </div>
            <p className="giftFont contestpadding" style={{ color: "#949494" }}>
              Guess and Win
            </p>
            <div className="contestpadding">
              <Button
                className="TossFontStyle contestButton"
                onClick={handleOpenChallenge}
              >
                Play Now
              </Button>
            </div>
          </div>
        </div>
        <div className="contestmaincontainer">
          <div
            style={{ background: "#000", margin: "3px", borderRadius: "10px" }}
          >
            <img
              src={bookIcon}
              alt=""
              className="contentimage"
              style={{ scale: "90%" }}
            />
          </div>
          <div className="constestContent">
            <div>
              <p className="TossFontStyle contestpadding">Book Cricket</p>
            </div>
            <p className="giftFont contestpadding" style={{ color: "#949494" }}>
              Play and Win
            </p>
            <div className="contestpadding">
              <Button
                className="TossFontStyle contestButton"
                onClick={handleOpenBookCricket}
              >
                Play Now
              </Button>
            </div>
          </div>
        </div>
        {/* {fantassy} */}
        <div className="contestmaincontainer">
          <div style={{ backgroundImage: `url(${fantasybagroundimage})`, borderRadius: "10px", margin: "3px" }}>
            <img src={fantassyimage} alt="" className="contentimage" />
          </div>
          <div className="constestContent">
            <div>
              <p className="TossFontStyle contestpadding">Fantasy League</p>
            </div>
            <p className="giftFont contestpadding" style={{ color: "#949494" }}>
            Play with fav. players
            </p>
            <div className="contestpadding">
              <Button
                className="TossFontStyle contestButton"
                onClick={handleOpenFantasy}
              >
                Play Now
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
